<template>
  <div class="form-panel">     
    <div class="form-panel__header">
      <h2 class="titulo-h2">Confirma tu Email</h2>
    </div>
    <div class="form-panel__body">
      <div class="form-fields form-fields-register">               
        <div class="form-fields__principal">
          <h2 class="titulo-h3-light">Ingresa tu dirección de correo</h2> 
          <form class="form" action="">  
            <div class="form__group" :class="{'form__group-invalid': $v.form.email.$error, 'form__group-valid': !$v.form.email.$invalid}">
              <i class="icon-field icon-field-email"></i>        
              <label for="email">Email</label>
              <input id="email" type="email" @blur="$v.form.email.$touch()" v-model="form.email">
              <div class="form__group-validation" v-if="$v.form.email.$dirty">
                <p v-if="!$v.form.email.required">Debes especificar un correo.</p>
                <p v-if="!$v.form.email.email">El formato de correo no es válido.gg</p>
              </div>
            </div>
            <div class="form__group" :class="{'form__group-invalid': $v.form.aceptarTerminos.$error, 'form__group-valid': !$v.form.aceptarTerminos.$invalid && !$v.form.aceptarTerminos.$invalid}">
              <i class="icon-field icon-field-checked"></i>
              <label for="aceptarTerminos">Acepto Términos</label>
              <div class="seleccionar">
                <v-switch v-model="form.aceptarTerminos" color="white" class="seleccionar-control" >
                </v-switch>
                <a href="https://www.lacentral.com.co/politicas/autorizacion-para-el-tratamiento-de-datos-personales/" target="_blank" class="seleccionar-etiqueta">Leer Autorización tratamiento de datos.</a>
              </div>
              
              <div class="form__group-validation" v-if="$v.form.aceptarTerminos.$dirty">
                <p v-if="!$v.form.aceptarTerminos.required">Debes aceptar los términos.</p>
              </div>
            </div>
            <div class="form__group form__group-register">
              <a class="waves-effect waves-light m-btn" tabindex="0" @click="$v.form.$invalid ? $v.form.$touch() : registrar()" @keyup.enter="$v.form.$invalid ? $v.form.$touch() : registrar()"> Registrarse</a>               
            </div> 
          </form>
        </div>        
      </div>
    </div>
  </div>   
</template>

<script>

import { required, email } from 'vuelidate/lib/validators';

export default {
  data(){
    return{
      form:{
        email: '',
        aceptarTerminos: false
      },
      accessToken: '' 
    };
  },
  created() {
    this.form.email = this.$route.params.email
    this.accessToken = this.$route.params.accessToken
  },
  methods:{
    registrar()
    {
      this.$store.dispatch('confirmarEmailExterno', { email: this.form.email, accessToken: this.accessToken })
    }
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      aceptarTerminos: {
        required
      }
    }   
  }
}
</script>